/**
 * @desc 供应商文件上传（合同，附件）
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierInfoAttachmentDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/upload/supplierFiles`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
